// src/components/JobCard.js
import React from "react";

const JobCard = ({ job, onApplyClick, onViewDetails }) => (
  <div className="job-card">
    <span className="job-card-jobid" style={{ fontWeight: "600" }}>{job.jobid}</span>
    <h3 className="job-role">{job.jobrole}</h3>
    <div className="job-location" style={{
    color: "#505666",
    marginBottom: "34px",
    marginTop: "0.24em",
    fontSize: "1.02rem",
  }}>
  {
    Array.isArray(job.location)
      ? job.location.join(", ")
      : job.location
  }
</div>
    <div className="job-card-btn-row">
      <button className="job-card-btn view-details" onClick={onViewDetails}>View Details</button>
      <button className="job-card-btn apply-now" onClick={onApplyClick}>Apply Now</button>
    </div>
  </div>
);

export default JobCard;
